import { render, staticRenderFns } from "./MailContentEditor.vue?vue&type=template&id=299f6664&scoped=true"
import script from "./MailContentEditor.vue?vue&type=script&lang=js"
export * from "./MailContentEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299f6664",
  null
  
)

export default component.exports